<template>
  <div class="content">
    <div class="input-title">
      <label>{{ component.label }}</label>
      <label v-if="isRequired()" style="color: #10dd2c"> *</label>
    </div>
    <div class="content-select">
      <select>
        <option value="">{{ component.placeholder }}</option>
      </select>
      <v-tooltip left>
        <template v-slot:activator="{}">
          <v-btn icon color="green darken-1">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectText',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  methods: {
    isRequired() {
      return this.component.rules.some(rule => {
        return (
          rule.key === 'required' &&
          (rule.value === true || rule.value === 'true')
        )
      })
    },
  },
}
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.input-title {
  font-weight: bold;
  font-size: 14;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 5px;
}
.content-select {
  background-color: #dddddd;
  border: 1px solid #cccccc;
  border-radius: 8px;
  padding: 10px;
  display: flex;
}
.content-select select {
  flex-grow: 1;
  width: 100%;
  border: none;
  color: #69739e;
  text-align: center;
}
select:focus {
  outline: none;
  box-shadow: none;
}
.content-select span {
  color: #10dd2c;
  padding-right: 15px;
  font-size: 18px;
}
</style>
